import type { Role } from "../../services/auth.service";

export interface NavItem {
  to: string;
  label: string;
  /** papéis que enxergam o item; ausente = todos os autenticados */
  roles?: Role[];
  end?: boolean;
}

export interface NavGroup {
  title: string;
  items: NavItem[];
  roles?: Role[];
}

/** Fonte única da navegação do Builder. */
export const navigation: NavGroup[] = [
  {
    title: "Meus sistemas",
    items: [
      { to: "/projects/new", label: "Criar sistema" },
      { to: "/dashboard", label: "Início" },
      { to: "/projects", label: "Meus sistemas", end: true },
      { to: "/templates", label: "Modelos" },
      { to: "/usage", label: "Consumo" },
      { to: "/billing", label: "Plano e pagamento" },
      { to: "/settings", label: "Ajustes" },
    ],
  },
  {
    title: "Administração",
    // Cliente não enxerga: só administra a própria empresa em Configurações.
    roles: ["superadmin", "master", "franqueado"],
    items: [
      { to: "/admin/organizations", label: "Organizações" },
      { to: "/admin/users", label: "Usuários" },
      { to: "/admin/plans", label: "Planos", roles: ["superadmin", "master"] },
      { to: "/admin/ai-providers", label: "Inteligência artificial", roles: ["superadmin", "master"] },
      { to: "/admin/observability", label: "Operação", roles: ["superadmin"] },
      { to: "/admin/system", label: "Sistema", roles: ["superadmin"] },
      { to: "/admin", label: "Administração", end: true },
    ],
  },
];

export function visibleGroups(role: Role | undefined): NavGroup[] {
  if (!role) return [];
  return navigation
    .filter((group) => !group.roles || group.roles.includes(role))
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => !item.roles || item.roles.includes(role)),
    }));
}
